import { deleteData, getData, postData } from '~/utils/service';
import {
  AcceptEmployerUserInvitationResponse,
  EmployerUserInvitationEligibilityResponse,
  EmployerUserInvitationSummary,
  VerifyEmployerUserInvitationResponse,
} from './types';

export const getColleagueInvitations = async (employerId: number) => {
  return getData<EmployerUserInvitationSummary[]>('employerUserInvitationsForEmployer', {
    pathParams: { employer_id: String(employerId) },
  });
};

export const sendColleagueInvitation = async (employerId: number, email: string) => {
  return postData<EmployerUserInvitationSummary>('employerUserInvitationsForEmployer', {
    pathParams: { employer_id: String(employerId) },
    data: { email },
  });
};

export const revokeColleagueInvitation = async (employerId: number, invitationId: number) => {
  return deleteData('employerUserInvitationsForEmployer', {
    pathParams: {
      employer_id: String(employerId),
      invitation_id: String(invitationId),
    },
  });
};

export const resendColleagueInvitation = async (employerId: number, invitationId: number) => {
  return postData<EmployerUserInvitationSummary>('employerUserInvitationResend', {
    pathParams: {
      employer_id: String(employerId),
      invitation_id: String(invitationId),
    },
  });
};

export const verifyColleagueInvitation = async (code: string) => {
  return getData<VerifyEmployerUserInvitationResponse>('employerUserInvitationVerify', {
    pathParams: { code },
  });
};

/** Signed-in callers only: would accepting this invitation fail for the current account? */
export const getColleagueInvitationEligibility = async (code: string) => {
  return getData<EmployerUserInvitationEligibilityResponse>('employerUserInvitationEligibility', {
    pathParams: { code },
  });
};

export const acceptColleagueInvitation = async (invitationCode: string) => {
  return postData<AcceptEmployerUserInvitationResponse>('employerUserFromInvitation', {
    data: { invitationCode },
  });
};
